import { z } from "zod";
import { PublicIdSchema } from "./common";

export const AdminRefueling = z.object({
  public_id: PublicIdSchema,
  driver_public_id: PublicIdSchema,
  driver_name: z.string(),
  attendance_public_id: PublicIdSchema,
  sequence: z.number().int().min(1).max(3),
  liters: z.string(),
  amount: z.number().int().min(0),
  /** 領収書画像の presigned URL (未アップロードは null) */
  receipt_image_url: z.string().nullable(),
  refueled_at: z.iso.datetime({ offset: true }),
  created_at: z.iso.datetime({ offset: true }),
});

export const ListAdminRefuelingsInput = z.object({
  driver_public_id: PublicIdSchema.optional(),
  /** 日付範囲 (attendance.work_date ベース) */
  from: z.iso.date().optional(),
  to: z.iso.date().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(100),
});

export type AdminRefuelingDto = z.infer<typeof AdminRefueling>;
export type ListAdminRefuelingsInputDto = z.infer<typeof ListAdminRefuelingsInput>;
